import { Component, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { IonIcon, IonLabel, IonMenu, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import { addIcons } from 'ionicons'
import {
	cashOutline,
	chevronDownOutline,
	chevronUpOutline,
	diamondOutline,
	dice,
	documentTextOutline,
	gameController,
	gameControllerOutline,
	homeOutline,
	list,
	star,
} from 'ionicons/icons'

import { DrawerComponent } from '../../shared/components/drawer/drawer.component'
import { AuthService } from '../../shared/services/auth.service'
import { DisplayService } from '../../shared/services/display.service'
import { WhiteLabelService } from '../../shared/services/white-label.service'
import { V3_HOME_ICON_NAME, V3_MY_BETS_ICON_NAME, V3_TAB_ICONS } from '../../skins/v3/icons/v3-tab-icons'
import { LoginModalService } from '../login/login-modal.service'

@Component({
	selector: 'app-tabs',
	templateUrl: 'tabs.page.html',
	styleUrls: ['tabs.page.scss'],
	standalone: true,
	imports: [IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, IonMenu, FormsModule, DrawerComponent, TranslatePipe],
})
export class TabsPage {
	isCompactTabBarExpanded = signal(false)

	constructor(
		private readonly displayService: DisplayService,
		private readonly authService: AuthService,
		private readonly loginModalService: LoginModalService,
		protected readonly whiteLabelService: WhiteLabelService,
	) {
		addIcons({
			star,
			homeOutline,
			list,
			cashOutline,
			documentTextOutline,
			diamondOutline,
			dice,
			gameController,
			gameControllerOutline,
			chevronDownOutline,
			chevronUpOutline,
			...V3_TAB_ICONS,
		})
	}

	protected readonly v3HomeIconName = V3_HOME_ICON_NAME

	protected readonly v3MyBetsIconName = V3_MY_BETS_ICON_NAME

	private handleCasinoNavigation(action: () => void) {
		if ((this.whiteLabelService.isV2Skin() || this.whiteLabelService.isV3Skin()) && this.authService.isDemoUser()) {
			void this.loginModalService.open('login')
			return
		}
		action()
	}

	openCasino() {
		this.handleCasinoNavigation(() => this.displayService.openCasino())
	}

	openAsianCasino() {
		this.handleCasinoNavigation(() => this.displayService.openAsianCasino())
	}

	toggleCompactTabBar() {
		this.isCompactTabBarExpanded.update((isExpanded) => !isExpanded)
	}
}
